export default __webpack_public_path__ + "static/media/md-card-bg-ml-python.ae28913d.png";